import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blog';
import { SectionHead } from './Services';

export function PostRow({ post, large = false }) {
  return (
    <li className="border-b border-line">
      <Link
        to={`/blog/${post.slug}`}
        className="group grid gap-3 py-8 md:grid-cols-12 md:gap-8"
      >
        <time className="text-sm text-muted md:col-span-2 md:pt-1.5">{post.published}</time>
        <h3
          className={`display-semi md:col-span-5 transition-colors duration-300 group-hover:text-accent ${
            large ? 'text-2xl sm:text-3xl' : 'text-xl sm:text-2xl'
          }`}
        >
          {post.title}
        </h3>
        <p className="text-muted md:col-span-5">{post.excerpt}</p>
      </Link>
    </li>
  );
}

export function PostSkeleton({ rows = 3 }) {
  return (
    <ul className="border-t border-line" aria-busy="true" aria-label="Loading posts">
      {Array.from({ length: rows }).map((_, i) => (
        <li key={i} className="grid gap-3 border-b border-line py-8 md:grid-cols-12 md:gap-8">
          <span className="h-4 w-24 rounded bg-raised md:col-span-2 animate-pulse" />
          <span className="h-7 rounded bg-raised md:col-span-5 animate-pulse" />
          <span className="h-14 rounded bg-raised md:col-span-5 animate-pulse" />
        </li>
      ))}
    </ul>
  );
}

export default function BlogPreview() {
  const recent = blogPosts.slice(0, 3);

  return (
    <section id="blog-preview" aria-labelledby="blog-title" className="relative py-24 sm:py-32">
      <div className="frame">
        <SectionHead id="blog-title" title="From the blog">
          Notes on engineering, AI and growing a business online.
        </SectionHead>

        <div className="mt-14">
          <ul className="border-t border-line">
            {recent.map((post) => (
              <PostRow key={post.slug} post={post} />
            ))}
          </ul>
        </div>

        <Link to="/blog" className="btn-ghost mt-10">
          All posts
        </Link>
      </div>
    </section>
  );
}
